export default __webpack_public_path__ + "static/media/Page_Under_Construction.78e318e4.png";